import { Box, Typography } from "@mui/material";
import CompanyLogo from "screens/user-profile/fields/company-logo";
import BioFieldInput from "screens/user-profile/fields/bio-field-input";
import DescriptionInput from "screens/user-profile/fields/description-input";
import ImageUploader from "../ImageUploder/ImageUploder";

interface Image {
  file?: Blob | MediaSource | ArrayBuffer;
  preview: string;
  fileName?: string;
  mimetype?: string;
}

const ProfileDetailsForm = ({ formik }: any) => {
  return (
    <Box
      border={1}
      borderColor="rgba(0,0,0,0.2)"
      borderRadius={2.5}
      flex={1}
      p={3}
    >
      <CompanyLogo
        logo={formik.values.logo}
        onLogoChange={(logo: Image) => formik.setFieldValue("logo", logo)}
        formik={formik}
      />

      {/* <CoverPhoto
        photos={formik.values.coverPhotos}
        onPhotoAdd={(photo: Image) =>
          formik.setFieldValue("coverPhotos", [
            ...formik.values.coverPhotos,
            photo,
          ])
        }
        onPhotoRemove={(index: number) =>
          formik.setFieldValue(
            "coverPhotos",
            formik.values.coverPhotos.filter((_: any, i: number) => i !== index)
          )
        }
        formik={formik}
      /> */}
      <Typography variant="h6" mb={2} fontFamily="Maven Pro, sans-serif">
        Cover Photos*
        <br />
        <Typography
          fontFamily="Inter"
          fontSize={14}
          color="#535862"
          sx={{
            display: "block",
            textIndent: "-1em",
            paddingLeft: "1em",
            whiteSpace: "pre-line",
          }}
        >
          **Images should be free of any messages, text, watermarks, company branding, or trip details.
        </Typography>
        <ImageUploader
          images={formik.values.coverPhotos}
          setImages={(photos: Image[]) =>
            formik.setFieldValue("coverPhotos", photos)
          }
          maxFileSize={10 * 1024 * 1024} // 5MB
          maxFiles={10}
          sequence={true}
          handleUpload={() => { }}
          allowedAspectRatios={[16 / 9, 16 / 10]}  //1.77   0.5625  1.6
          allowedRange={[1.55, 1.8]}
          noUpload={true}

        />
      </Typography>

      {/* Bio Field */}
      <BioFieldInput
        name="bio"
        type="text"
        label="Bio"
        formik={formik}
        value={formik.values.bio}
      />

      {/* Descriptions */}
      <DescriptionInput formik={formik} />
    </Box>
  );
};

export default ProfileDetailsForm;
